export default __webpack_public_path__ + "static/media/Vision.9f89000b.png";